import axios from 'axios'
import lineChart from '@/components/charts/lineChart.vue'
import moment from 'moment'
import Loader from '@/components/Loader/Loader.vue'
import Toast from 'vue-toastification'
import { Modal } from 'flowbite';

export default {
    name: 'AccountReport',
    components: { lineChart, Loader },
    data() {
        return {
            moment: moment,
            isCompare: false,
            interval: 'day',
            loader: false,
            loadertable: false,
            widthMapper: {
                'full': 'ui sixteen wide column',
                'half': 'ui eight wide column'
            },
            dateRange: {
                startDate: moment().subtract(1, 'months').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            allTablesData: [],
            regex: /^(https?|http):\/\/[^\s/$.?#].[^\s]*$/i,
            graphArrayFirst: [],
            graphArraySecond: [],
            specialChar: '',
            optionData: [],
            firstGraphSelectedList: [],
            secondGraphSelectedList: [],
            platformDropdownData:'',
            selectedPlatform:{platform:'all', plateform_id:'0'},
            selectedApprovedFilter: {value:'all', label:'All'},
            selectedStatusFilter: {value:'all', label:'All'},
            isForgetPassword: false,
            // edit form data
            editDateRange: {
              startDate: moment().format("YYYY-MM-DD"),
              endDate: moment().format("YYYY-MM-DD")
            },
            ID:'',
            brandName:'',
            platform:'',
            approvedBy:'',
            othersApprovedBy:'',
            otherPlatform:'',
            NDA: false,
            NDAFile:'',
            contract: false,
            contractFile: '',
            POCClientEmail:'',
            POCClientNumber:'',
            POCClientEmailSecond:'',
            POCClientNumberSecond:'',
            lyxelAMEmail:'',
            LyxelAMName:'',
            LyxelAMNumber:'',
            LyxeSupEmail:'',
            LyxelSupName:'',
            LyxelSupNumber:'',
            SOW: false,
            SOWFile:'',
            remark:'',
            LOB:'',
            LobList:['Media', 'Weavr', 'Ecom', 'SEO', 'Social Media', 'Tech Development', 'Tech Retainer', 'Squarebagel', 'Video', 'Photo/Reels', 'Lyrkl','Ekaliedo', 'Automation', 'Bringin'],
            // validation variable 
            brandNameValidation: false,
            platformValidation: false,
            viewModal :'',
            viewModalLink:''
        }
    },
    created(){
      
    },
    mounted() {
        self = this
        self.getTableData()
        self.getPlatformDropdownData()
        this.initializeModal();
        window.addEventListener('load', function() {
          console.log("chefskjdf")
          var iframe = document.getElementById('viewIframe');
          var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    
          // Apply CSS styles to the image within the iframe
          var iframeImage = iframeDocument.querySelector('img');
          if (iframeImage) {
            // iframeImage.style.border = '2px solid red';
            // iframeImage.style.borderRadius = '5px';
            var imageWidth = iframeImage.clientWidth;
        
            // Apply the image width to the body of the parent document
            document.body.style.width = imageWidth + 'px';
          }
        });
    },

    methods: {
        dateChange() {
            this.dateRange.startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD"),
            this.dateRange.endDate = moment(this.dateRange.endDate).format("YYYY-MM-DD")
            this.allFilters()
        },
        initializeModal(){
            const $targetEdit = document.getElementById('edit-modal');
            // options with default values
            const editModal = {
              placement: 'center',
              backdrop: 'dynamic',
              backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-40',
              closable: true,
              onHide: () => {
                  $('#adgroup-tbl').DataTable().destroy();
              },
              onShow: () => {
                  console.log('modal is shown');
              }
            };
            this.editModal = new Modal($targetEdit, editModal);

            const $targetView = document.getElementById('view-data-modal');
            const viewModal = {
              placement: 'center',
              backdrop: 'dynamic',
              backdropClasses: 'bg-gray-900 bg-opacity-50 fixed inset-0 z-40',
              closable: true,
              onHide: () => {
                  // $('#adgroup-tbl').DataTable().destroy();
                  this.viewModalLink = ''
              },
              onShow: () => {
                  console.log('modal is shown');
              }
            };
            this.viewModal = new Modal($targetView, viewModal);
        },
        checkLink(value) {
            this.regex.test(value)
        },

        getPlatformDropdownData(){
            self = this
            self.loader = false
            self.allTablesData = []
            let url = "/api/v1/Get_all_platforms"
            axios.get(url).then((response) => {
                self.loader = false
                self.platformDropdownData = response.data.data 
                self.platformDropdownData.splice(0,0,{platform:'all',platform_id:'0'})  
            }).catch(err => {
                self.loader = false
            })
        },
        downloadFileEvery(link){
          console.log("check",link)
          // window.location = link
        },
        viewModalOpen(link){
          this.viewModalLink= link
          this.viewModal.show()
        },
        editModalOpen(rowData){
            console.log(rowData)
            this.ID = rowData.lyxel_id
            this.brandName= rowData.brand_name
            this.platform= rowData.platform
            this.NDA= rowData.nda
            this.NDAFile= rowData.nda_file
            this.contract= rowData.contract
            this.contractFile= rowData.contract_file
            this.POCClientEmail= rowData.poc_client_email
            this.POCClientNumber= rowData.poc_client_number
            this.POCClientEmailSecond= rowData.poc_client_email_2
            this.POCClientNumberSecond= rowData.poc_client_number_2
            this.lyxelAMEmail= rowData.lyxel_am_email
            this.LyxelAMName= rowData.lyxel_am_name
            this.LyxelAMNumber= rowData.lyxel_am_number
            this.LyxelSupName= rowData.lyxel_supervisor_name
            this.LyxeSupEmail = rowData.lyxel_supervisor_email
            this.LyxelSupNumber=rowData.lyxel_supervisor_number
            this.SOW= rowData.sow
            this.SOWFile= rowData.sow_file
            this.remark= rowData.remark
            this.approvedBy= rowData.approved_by
            this.LOB = rowData.lob
            this.editDateRange= {
              startDate: moment(rowData.contract_validity).format("YYYY-MM-DD"),
              endDate: moment(rowData.contract_validity).format("YYYY-MM-DD")
             },
            this.editModal.show()
        },
        updateData(){
            let self = this
            let formData = new FormData()
            if(self.brandName.length<4){
              this.brandNameValidation = true
              return false
            }
      
            if(self.platform.length=='0'){
              this.platformValidation = true
              return false
            }
            
            if(this.validEmail(this.LyxeSupEmail))
            {
                this.toast();
                alert("check all ")
                return false;
            }
            self.loader1 = true
      
            formData.append("brand_name",self.brandName)
            formData.append("lob",self.LOB)
      
            if(self.platform!='others')
              formData.append("platform",self.platform)
            else
              formData.append("platform",self.otherPlatform)
            
            if(self.approvedBy!='etc')
              formData.append("approved_by",self.approvedBy)
            else
              formData.append("approved_by",self.othersApprovedBy)

            formData.append("lyxel_id",self.ID)
            formData.append("poc_client_email",self.POCClientEmail)
            formData.append("contract",self.contract)
            formData.append("contract_file",self.contractFile)
            formData.append("contract_validity",self.dateRange.endDate)
            formData.append("nda",self.NDA)
            formData.append("nda_file",self.NDAFile)
            formData.append("sow",self.SOW)
            formData.append("sow_file",self.SOWFile)
            formData.append("poc_client_number",self.POCClientNumber)
            formData.append("poc_client_email_2",self.POCClientEmailSecond)
            formData.append("poc_client_number_2",self.POCClientNumberSecond)
            formData.append("lyxel_am_email",self.lyxelAMEmail)
            formData.append("lyxel_am_name",self.LyxelAMName)
            formData.append("lyxel_am_number",self.LyxelAMNumber)
            formData.append("lyxel_supervisor_email",self.LyxeSupEmail)
            formData.append("lyxel_supervisor_name",self.LyxelSupName)
            formData.append("lyxel_supervisor_number",self.LyxelSupNumber)
            formData.append("remark",self.remark)
      
            // # console.log("check ?",Object.fromEntries(formData))
      
            console.log("payload",formData)
            let url = '/api/v1/EditFormData'
            axios.post(url,formData).then((respons)=>{
              self.loader1 = false
              self.emptyVariable()
            }).catch((error)=>{
              self.loader1 = false
              self.$toast.error("Error!", {
                position: "bottom-center",
                timeout: 2000,
                closeOnClick: true,
                pauseOnFocusLoss: true,
                pauseOnHover: true,
                draggable: true,
                draggablePercent: 0.6,
                showCloseButtonOnHover: false,
                hideProgressBar: true,
                closeButton: "button",
                icon: true,
                rtl: false
              });     
            })
          },
          validEmail(email) {
            var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
          },
          validNumber(number){
              var no=/^[0-9]{10}$/;
              return no.test(number);
          },
          deletField(id){
            let self = this
            let payload ={
              "lyxel_id": id
            }
            // # console.log("check ?",Object.fromEntries(formData))
            if(confirm("Confirm Delete")){
              let url = '/api/v1/DeleteFormData'
              axios.post(url,payload).then((respons)=>{
                self.allFilters();
              }).catch((error)=>{
                self.loader1 = false
                self.$toast.error("Error!", {
                  position: "bottom-center",
                  timeout: 2000,
                  closeOnClick: true,
                  pauseOnFocusLoss: true,
                  pauseOnHover: true,
                  draggable: true,
                  draggablePercent: 0.6,
                  showCloseButtonOnHover: false,
                  hideProgressBar: true,
                  closeButton: "button",
                  icon: true,
                  rtl: false
                });     
              })
            };
            
          },
        toast(){
          self.$toast.error("Enter valid email", {
            position: "bottom-center",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: true,
            closeButton: "button",
            icon: true,
            rtl: false
          });     
        },
        mergeContract(contract, sow){
          this.loader = true;
          const url = "/api/v1/Merge_Document";
          const payload = {
            source_url: contract[0],
            targate_url: sow[0]
          };

          axios.post(url,payload).then(res => {
            this.getTableData();
            this.$toast.success('Document merging successful', {
              position: "top-right",
              timeout: 3000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });
            this.loader = false;
          }).catch(err => {
            self.$toast.error(err.response.data.summary, {
              position: "bottom-center",
              timeout: 2000,
              closeOnClick: true,
              pauseOnFocusLoss: true,
              pauseOnHover: true,
              draggable: true,
              draggablePercent: 0.6,
              showCloseButtonOnHover: false,
              hideProgressBar: true,
              closeButton: "button",
              icon: true,
              rtl: false
            });  
            this.loader = false;
            console.log(err.response.data.summary)
            
          })
        },
        allFilters(){
          $('#table_dynamic_report_').DataTable().destroy()
          this.getTableData()
        },
        getTableData() {
            let self = this
            // $('#table_dynamic_report_').DataTable().destroy()
            self.allTablesData = []
            var search = require("@/assets/Icons_SVG/Search.svg");

            let url = "/api/v1/GetFormData?filter_start_date="+self.dateRange.startDate+"&filter_end_date="+self.dateRange.endDate+"&filter_is_approved="+self.selectedApprovedFilter.value+"&filter_status="+self.selectedStatusFilter.value+"&filter_platform="+self.selectedPlatform.platform
            self.loadertable = true
            axios.get(url).then((response) => {
                self.loadertable = false
                self.allTablesData = response.data
                this.$nextTick(() => {
                    $('#table_dynamic_report_').dataTable()
                    $('#table_dynamic_report_').DataTable().destroy()
                    $('#table_dynamic_report_').DataTable({
                        scrollX: true,
                        lengthChange: true,
                        info: false,
                        sorting: [[7, "asc"]],
                        initComplete: function(settings, json) {
                            $('.dataTables_scrollBody tfoot tr').css({visibility:'collapse'});
                            $('.dataTables_scrollBody thead tr').css({visibility:'collapse'});
                        },
                        language: {
                            search: "", searchPlaceholder: "Search...", paginate: {
                                first: "",
                                previous: "<",
                                next: ">",
                                last: "",
                            },
                            lengthMenu: "<h5>Show entries</h5> _MENU_"
                        },
                    })
                    $('#table_dynamic_report_filter > label').append(
                        `<div class='search_icon'><img src='${search}' /></div>`
                    );
                });
            }).catch(err => {
                self.loadertable = false
            })
        },

    }

}